<template>
  <div>
    <h2 class="title-2 text-left">Referências</h2>
    <p>
      Brasil. Ministério da Saúde.
      <b>Portaria GM/MS nº 3493, de 10 de abril de 2024</b>. Altera a Portaria
      de Consolidação GM/MS nº 6, de 28 de setembro de 2017, para instituir nova
      metodologia de cofinanciamento federal do Piso de Atenção Primária à Saúde
      no âmbito do Sistema Único de Saúde (SUS). Diário Oficial da União,
      Brasília, DF, n. 70, seção 1, p. 100, 11 abr. 2024.
    </p>
    <p>
      CONASEMS.
      <b>Estação SUS - Episódio 7 - Financiamento da Atenção Básica</b>. [S.l.]:
      CONASEMS, 2024. 1 vídeo (34 min 22 s). Publicado pelo canal do CONASEMS.
      Disponível em: https://www.youtube.com/watch?v=D3yw0d88JAE. Acesso em: 25
      abr. 2024.
    </p>
    <p>
      <b>BRASIL. Ministério da Saúde. Gabinete da Ministra.</b> Portaria GM/MS
      nº 3.732, de 7 de maio de 2024. Define o valor per capita anual com base
      em critério populacional e estabelece a manutenção do valor nominal
      repassado no ano anterior para municípios com decréscimo populacional,
      válidos para o ano de 2024, no âmbito do Financiamento de Atenção Primária
      à Saúde. Diário Oficial da União: seção 1, Brasília, DF, 10 maio 2024. p.
      262.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
